export const JobTypes = {
  AI: "App\\Jobs\\ImportCV",
};

export const TypeOfWork = {
  FULL_TIME: "Full-time",
  PART_TIME: "Part-time",
  CONTRACT: "Contract",
  CASUAL: "Casual",
};

export const Salary = {
  JUNIOR: "Junior",
  MID: "Mid",
  SENIOR: "Senior",
  EXECUTIVE: "Executive",
  UNSPECIFIED: "Unspecified",
};

export const JobStatus = {
  QUEUED: "queued", // queued on frontend
  PENDING: "pending", // in Lavarvel / API queue
  IMPORTING_PERSONAL_DETAILS: "importing_personal_details",
  IMPORTING_CV: "importing_cv",
  COMPLETE: "completed",
  FAILED: "failed",
};

export const CVProcessingStages = {
  PERSONAL_DETAILS: "personal_details",
  SKILLS: "skills",
  ROLES: "roles",
  PROJECTS: "projects",
  EDUCATION: "education",
  CULTURE: "culture",
  JSON_RESUME: "json_resume",
};

export const Routes = {
  HOME: "home",
  CANDIDATES: "candidates",
  CANDIDATE: "candidate",
  FLOATS: "floats",
  FLOAT_CREATE: "floats/create",
  SUBMISSIONS: "submissions",
  SUBMISSION_CREATE: "submissions/create",
  INTEGRATIONS: "integrations",
  CONTACTS: "contacts",
  COMING: "coming",
  ASSISTANT: "assistant",
};

// Which record type the dashboard analytics are focused on
export const DASHBOARD_FOCUS = {
  FLOATS: "floats",
  SUBMISSIONS: "submissions",
};

export const NotificationTypes = {
  EMAIL_OPENED: "email_opened",
  EMAIL_LINK_CLICKED: "email_link_clicked",
  EMAIL_BOUNCED: "email_bounced",
  EMAIL_UNSUBSCRIBED: "email_unsubscribed",
  PAGE_VIEWED: "viewed",
  CANDIDATE_IS_INTERESTED: "candidate_is_interested",
  CANDIDATE_ASK_QUESTION: "candidate_ask_question",
  CANDIDATE_NOT_INTERESTED: "candidate_not_interested",
  CANDIDATE_BOOK_INTERVIEW: "candidate_book_interview",
  CANDIDATE_GIVE_FEEDBACK: "candidate_give_feedback",
  CANDIDATE_VIEW_MORE: "candidate_view_more",
};

export const FEATURES = {
  DASHBOARD: "dashboard",
  FLOATS: "floats",
  CANDIDATES: "candidates",
  CONTACTS: "contacts",
  INTEGRATIONS: "integrations",
  JOBS: "jobs",
  SUBMISSIONS: "submissions",
};

export const PEOPLE_SORT_OPTIONS = {
  UPDATED_AT: "updated_at",
  NAME: "name",
  POSITION: "position_title",
};

export const FLOAT_SORT_OPTIONS = {
  CREATED_AT: "created_at",
  UPDATED_AT: "updated_at",
  NAME: "name",
  SENT_DATE: "sent_date",
};

export const CONTACT_SORT_OPTIONS = {
  COMPANY: "company",
  CREATED_AT: "created_at",
  FIRST_NAME: "first_name",
  LAST_NAME: "last_name",
  LAST_CONTACTED_AT: "last_contacted_at",
  UPDATED_AT: "updated_at",
};

export const TAG_TYPE = {
  CONTACT: "contact",
  CANDIDATE: "candidate",
  JOBADDER: "jobadder",
  UNIFIED: "unified",
  TAG: "tag",
};

export const CONTACT_SOURCE = {
  FLOATS: "floats",
  JOBADDER: "jobadder",
  UNIFIED: "unified",
};

export const SAVE_METHOD = {
  SYNC: "sync",
  ASYNC: "async",
  SKIP: "skip",
};

export const PLAN_TYPES = {
  TRIAL: "trial",
  ADMIN: "admin",
};

export const USER_ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  TEAM_ADMIN: "team_admin",
  MEMBER: "member",
};

export const FLOAT_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
  SENT: "sent",
  ARCHIVED: "archived",
};

export const SUBMISSION_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
  SENT: "sent",
  ARCHIVED: "archived",
};

export const SUBMISSION_SORT_OPTIONS = {
  CREATED_AT: "created_at",
  UPDATED_AT: "updated_at",
  NAME: "name",
  SENT_DATE: "sent_date",
};

export const FLOAT_CONTACT_STATUS = {
  DRAFT: "Draft",
  EMAILED: "Emailed",
  SHARED: "Shared",
  OPENED: "Opened",
  VIEWED: "Viewed",
  BOUNCED: "Bounced",
  UNSUBSCRIBED: "Unsubscribed",
};

export const THEME_TYPES = {
  STARTUP: "startup",
  PROFESSIONAL: "professional",
  SPOTLIGHT: "spotlight",
  LIGHT: "light",
  SNOW: "snow",
};

export const EMAIL_STYLE = {
  STYLED: "styled",
  TEXT_ONLY: "text_only",
};

export const FLOAT_MESSAGE = {
  IM_INTERESTED: 1,
  ASK_QUESTION: 2,
  NOT_INTERESTED: 6,
};

export const SUBMISSION_MESSAGE = {
  BOOK_INTERVIEW: 4,
  GIVE_FEEDBACK: 5,
  NOT_INTERESTED: 6,
};

export const SCHEDULED_MESSAGES_BY = {
  FLOAT: "float",
  FLOAT_EMAIL: "float_email",
};

export const SCHEDULED_MESSAGE_STATUS = {
  SCHEDULED: "scheduled",
  SENT: "sent",
  CANCELED: "canceled",
};

export const ANONYMIZE_MODE = {
  NAME_AND_COMPANY: "name_and_company",
  NAME_ONLY: "name_only",
  LAST_NAME_ONLY: "last_name_only",
};

export const FILE_DRAG_STATE = {
  initial: "initial",
  dragging: "dragging",
  rejected: "rejected",
  processing: "processing",
};

export const JOB_LISTING_SORT_OPTIONS = {
  UPDATED_AT: "updated_at",
  TITLE: "title",
  CREATED_AT: "created_at",
};

export const JOB_LISTING_TYPE_OF_WORK = {
  FULL_TIME: 0,
  PART_TIME: 1,
  CONTRACT: 2,
  CASUAL: 3,
};

export const JOB_LISTING_TYPE_OF_WORK_LABELS = {
  0: "Full-time",
  1: "Part-time",
  2: "Contract",
  3: "Casual",
};

export const JOB_LISTING_REMOTE_TYPE = {
  ON_SITE: "on_site",
  REMOTE: "remote",
  HYBRID: "hybrid",
};

export const JOB_LISTING_REMOTE_TYPE_LABELS = {
  on_site: "On Site",
  remote: "Remote",
  hybrid: "Hybrid",
};

export const JOB_LISTING_STATUS = {
  DRAFT: "draft",
  ACTIVE: "active",
  CLOSED: "closed",
};

export const ACCOUNT_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  TRIAL_EXPIRED: "trial_expired",
  PLAN_EXPIRED: "plan_expired",
  INVITED: "invited",
  NOT_REGISTERED: "not_registered",
  INVALID_TOKEN: "invalid_token",
};

// Preset options for the per-candidate "Status chip" shown above the candidate
// name on public Float/Submission pages and in the creation preview. Users can
// also pick "None" (no chip) or enter custom text up to STATUS_CHIP_MAX_LENGTH.
export const STATUS_CHIP_OPTIONS = [
  "Available Now",
  "Open to Offers",
  "In High Demand",
  "Actively Interviewing",
  "Contract Ending Soon",
];

export const STATUS_CHIP_DEFAULT = "Available Now";

export const STATUS_CHIP_MAX_LENGTH = 25;
